// Утилита для парсинга CSV данных
const csvData = `Команда;Помощник
1;https://disk.yandex.ru/i/vTHpoqOuNlJ6FA
2;https://disk.yandex.ru/i/vTHpoqOuNlJ6FA
3;https://wiki.rtmis.ru/pages/viewpage.action?pageId=84574508
4;Простите, у меня лапки
5;https://wiki.rtmis.ru/pages/viewpage.action?pageId=84574508
6;https://disk.yandex.ru/i/vTHpoqOuNlJ6FA
7;Простите, у меня лапки
8;https://disk.yandex.ru/i/vTHpoqOuNlJ6FA
9;Простите, у меня лапки
10;https://wiki.rtmis.ru/pages/viewpage.action?pageId=84574508`;

export const parseCSV = () => {
  const lines = csvData.split('\n');
  const headers = lines[0].split(';');
  const data = {};
  
  for (let i = 1; i < lines.length; i++) {
    const line = lines[i].trim();
    if (line) {
      const values = line.split(';');
      const teamNumber = values[0];
      const helperMessage = values[1];
      data[teamNumber] = helperMessage;
    }
  }
  
  return data;
};

export const getHelperMessage = (teamNumber) => {
  const data = parseCSV();
  return data[teamNumber] || null;
};
